import { useStaticQuery, graphql } from 'gatsby';

// import { css } from '@emotion/react';
import { MDXProvider } from '@mdx-js/react';
import mdxComponents from '../components/mdxComponents';

import '../html.scss';

import NavBar from '../components/NavBar/NavBar';
import Footer from '../components/Footer/Footer';
import CookieConsent from 'react-cookie-consent';

// import { rhythm } from '../utils/typography';
export default function Layout({ className, children, pageContext }) {
	// console.log(pageContext?.layoutClasses);
	const { i18NJson: i18n } = useStaticQuery(graphql`
		query {
			i18NJson {
				ui {
					cookieConsent_header
					cookieConsent_message
					cookieConsent_allow
					cookieConsent_decline
				}
			}
		}
	`);

	return (
		<div id="app" className={className}>
			<NavBar />
			<MDXProvider components={mdxComponents}>{children}</MDXProvider>
			<Footer />
			<CookieConsent
				location="bottom"
				enableDeclineButton
				cookieName="gatsby-gdpr-google-analytics"
				style={{ background: '#001011' }}
				buttonStyle={{ background: '#fff', color: '#001011' }}
				declineButtonStyle={{
					background: 'transparent',
					color: '#fff',
				}}
				buttonText={i18n.ui.cookieConsent_allow}
				declineButtonText={i18n.ui.cookieConsent_decline}
			>
				{i18n.ui.cookieConsent_message}
			</CookieConsent>
		</div>
	);
}
